import React from "react";
import DropdownMenu from "./DropdownMenu";

const ModelDropdowns = ({ selectedModel, selectedInit, initializationOptions, onSelectChange }) => {
    const currentIdx = initializationOptions.findIndex(o => o.value === selectedInit);

    const prevInit = () => {
        if (currentIdx < initializationOptions.length - 1) {
            const synth = { target: { value: initializationOptions[currentIdx + 1].value } };
            onSelectChange(synth, "Initialization");
        }
    };

    const nextInit = () => {
        if (currentIdx > 0) {
            const synth = { target: { value: initializationOptions[currentIdx - 1].value } };
            onSelectChange(synth, "Initialization");
        }
    };

    const currentLabel = initializationOptions.find(o => o.value === selectedInit)?.label || "—";

    return (
        <div className="sidebar-section">
            <div className="sidebar-section-title">Model</div>
            <DropdownMenu
                label="Select Model"
                selectedValue={selectedModel}
                options={[
                    { value: "fcnv2_gfs", label: "FourCastNet v2-small" },
                    { value: "fcnv2_ifs", label: "FourCastNet v2-small IFS" },
                    { value: "pw_gfs", label: "Pangu-Weather" },
                    { value: "pw_ifs", label: "Pangu-Weather IFS" },
                    { value: "gc_gfs", label: "GraphCast Operational" },
                    { value: "gc_ifs", label: "GraphCast Operational IFS" },
                    { value: "au_gfs", label: "Aurora" },
                    { value: "au_ifs", label: "Aurora IFS" },
                    { value: "gfs_gfs", label: "GFS" },
                    { value: "ifs_ifs", label: "IFS" },
                    { value: "aifs_aifs", label: "AIFS" },
                    { value: "compare", label: "Comparison" },
                ]}
                onChange={(e) => onSelectChange(e, "Model")}
                className="sidebar-select"
            />

            <div className="sidebar-section-title" style={{ marginTop: 14 }}>Initialization</div>
            <div className="init-nav">
                <button
                    className="init-arrow"
                    onClick={prevInit}
                    disabled={currentIdx >= initializationOptions.length - 1}
                >
                    <svg width="8" height="12" viewBox="0 0 8 12" fill="currentColor"><path d="M7 1L2 6l5 5"/></svg>
                </button>
                <div className="init-display">{currentLabel}</div>
                <button
                    className="init-arrow"
                    onClick={nextInit}
                    disabled={currentIdx <= 0}
                >
                    <svg width="8" height="12" viewBox="0 0 8 12" fill="currentColor"><path d="M1 1l5 5-5 5"/></svg>
                </button>
            </div>
        </div>
    );
};

export default ModelDropdowns;
